import React from "react"
import { Field } from "redux-form"
import { Link } from "react-router-dom"

import emailValidator from "email-validator"

import BasicField from "./BasicField"
import PasswordField from "./PasswordField"
import BasicCheckbox from "./BasicCheckBox"
import { CONSTANTS, PATH } from "../modules/constants"
import { validatePass } from "../services/validators"

export const userValidate = values => {
  const errors = {}

  if (!values.name) {
    errors.name = "required"
  }

  if (!values.email) {
    errors.email = "required"
    // } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,20}$/i.test(values.email)) {
  } else if (!emailValidator.validate(values.email)) {
    errors.email = "invalid email address"
  }

  if (!values.password) {
    errors.password = "required"
  }
  else {
    var res = validatePass(values.password)

    if (!res.valid) {
      errors.password = res.message
    }
  }

  if (CONSTANTS.ENTER_PASSWORD_TWICE) {
    if (!values.password2) {
      errors.password2 = "required"
    }
    else {
      if (values.password !== values.password2) {
        errors.password2 = "both passwords must match"
      }
      else if (!values.dataUseAgreement || (values.dataUseAgreement < 1)) {
        errors.dataUseAgreement = "your agreement is required to continue"
      }
    }
  } else if (values.password && res.valid && (!values.dataUseAgreement || values.dataUseAgreement < 1)) {
    errors.dataUseAgreement = "your agreement is required to continue"
  }

  return errors
}

export const UserDetails = ({ brandColor }) => (
  <div className="userDetails">
    <div className="field">
      <Field name="name" label="Name" type="text" spellCheck={false} autoComplete="name" component={BasicField} />
    </div>
    <div className="field">
      <Field name="email" label="Email" type="text" spellCheck={false} autoComplete="username email" validateOnBlur component={BasicField} />
    </div>
    <div className="field">
      <Field name="password" label="Password" type="password" autoComplete="new-password" hint="minimum of eight characters, with at least one number" component={PasswordField} />
    </div>
    {CONSTANTS.ENTER_PASSWORD_TWICE && <div className="field">
      <Field name="password2" label="Confirm password" type="password" autoComplete="new-password" component={PasswordField} />
    </div>
    }
    <div className="field">
      <Field name="dataUseAgreement" style={{ fill: brandColor }}
        label={<span>I agree to the <Link to={`/${PATH.T_AND_C}`} style={{ color: brandColor }} >Web App Terms and Conditions</Link> and the <Link to={`/${PATH.PRIVACY}`} style={{ color: brandColor }} >Privacy Policy</Link> </span>}
        brandColor={brandColor}
        component={BasicCheckbox}
      />
    </div>
    <div className="field">
      <Field
        name="marketingUseAgreement"
        label="I'd like to receive occasional updates on Numerable (I can unsubscribe at any time)"
        brandColor={brandColor}
        component={BasicCheckbox} />
    </div>
  </div>
)

export default UserDetails
